import { useTranslation } from 'react-i18next';
import { GridAlignment, GridColDef } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { useState, ChangeEvent, FC, useEffect } from 'react';
import { MAX_PAGE_LIMIT } from '../../constants/numbers';
import BaranDataGrid from '../common/BaranDataGrid';
import { filterList } from '../../utils/array';
import { useNavigate } from 'react-router-dom';
import { IAdPage } from '../../interfaces/pages';
import IResponse, { IPagination } from '../../interfaces/response';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import { Box } from '@mui/material';

type IAdPagesTable = {};
const ListOfMyPages: FC<IAdPagesTable> = () => {
	const [pageSize, setPageSize] = useState(MAX_PAGE_LIMIT);
	const [page, setPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState('');
	const [fetchedData, setFetchedData] = useState<IAdPage[]>([]);
	const [pagination, setPagination] = useState<IPagination | null>();
	const [loading, setLoading] = useState(false);

	const headerClassNames = 'text-xs bg-background-paper';

	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleViewPage = (id: any) => {
		navigate(`/my-social-media/edit/${id}`);
	};

	const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(event.target.value);
	};

	const handleCreateNewPackage = () => {
		navigate(`/my-social-media/new`);
	};

	const properties: (keyof IAdPage)[] = ['handle_name', 'admin_name', 'media', 'user_name'];

	const filteredRows = filterList(fetchedData, properties, searchTerm);

	const columns: GridColDef<IAdPage>[] = [
		{
			field: 'id',
			headerName: t('row'),
			width: 90,
			headerAlign: 'center' as GridAlignment,
			align: 'center' as GridAlignment,
			headerClassName: headerClassNames,
			renderCell: params => {
				const rowIndex = filteredRows.indexOf(params.row);
				return (page - 1) * pageSize + (rowIndex + 1);
			},
		},
		{
			field: 'media',
			headerName: t('platform'),
			flex: 1,
			headerAlign: 'left' as GridAlignment,
			align: 'left' as GridAlignment,
			headerClassName: headerClassNames,
			renderCell: params => {
				return t(params.row.media);
			},
		},
		{
			field: 'user_name',
			headerName: t('user_name'),
			flex: 1,
			headerAlign: 'left' as GridAlignment,
			align: 'left' as GridAlignment,
			headerClassName: headerClassNames,
		},
		{
			field: 'admin_name',
			headerName: t('admin_name'),
			flex: 1,
			headerAlign: 'center' as GridAlignment,
			align: 'center' as GridAlignment,
			headerClassName: headerClassNames,
		},
		{
			field: 'created_at',
			flex: 1,
			headerName: t('created_time'),
			headerAlign: 'center',
			align: 'center',
			headerClassName: headerClassNames,
			renderCell: (params: any) => {
				return new Date(params.row.created_at).toLocaleDateString('fa-IR');
			},
		},
		{
			field: 'handle_name',
			headerName: t('Username'),
			width: 250,
			headerAlign: 'left' as GridAlignment,
			align: 'left' as GridAlignment,
			headerClassName: headerClassNames,
		},
		{
			field: 'action',
			headerName: t('action'),
			minWidth: 150,
			headerAlign: 'center' as GridAlignment,
			align: 'center' as GridAlignment,
			headerClassName: headerClassNames,
			renderCell: params => {
				return (
					<>
						<IconButton aria-label="eye" onClick={() => handleViewPage(params.id)}>
							<VisibilityIcon className="text-text-secondary" />
						</IconButton>
						<IconButton aria-label="eye" onClick={() => handleViewPage(params.id)}>
							<EditIcon className="text-text-secondary" />
						</IconButton>
					</>
				);
			},
		},
	];

	useEffect(() => {
		setLoading(true);
		axios<IResponse<IAdPage[]>>({
			url: `/media_entities/my`,
			params: {
				page: page,
				limit: pageSize,
				search: searchTerm,
				field: properties[0],
			},
		})
			.then(res => {
				if (res.data.success) {
					setPagination(res.data.pagination);
					setFetchedData(res.data.data);
				}
			})
			.finally(() => {
				setLoading(false);
			});
	}, [page, pageSize]);

	return (
		<Box className={`mb-14 w-full`}>
			<BaranDataGrid<IAdPage> loading={loading} exportExcel={true} pagination={pagination} rows={fetchedData} columns={columns} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} searchTerm={searchTerm} handleSearch={handleSearch} searchableFields={properties} actionButtonLable={t('create_new_media')} onClick={handleCreateNewPackage} />
		</Box>
	);
};

export default ListOfMyPages;
